/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* eslint-disable */
/**
 * P2P Order Side
 */
export enum P2POrderSide {
  BUY = 'BUY',
  SELL = 'SELL',
}
